import React, { useState, useEffect, useRef } from "react";
import { sendTestMatomoEvent } from "../../Analytics/MatomoManager/matomoTest";
import { Translate } from "../LanguageChanger";
 
const VideoLanguagePage = ({
  player,
  onBitrateChange,
  handleLanguageChange,
  handleSubtitleChange,
  subtitle,
  language,
  itemData,
  CurrentItemData,
}) => {
  const languageMap = {
    English: "en",
    Spanish: "es",
    French: "fr",
    German: "de",
    Italian: "it",
    Portuguese: "pt",
    Chinese: "zh",
    Japanese: "ja",
    Korean: "ko",
    Hindi: "hi",
    Arabic: "ar",
    Russian: "ru",
    Kannada: "kn",
    Tamil: "ta",
    Telugu: "te",
    Malayalam: "ml",
    Marathi: "mr",
    Bengali: "bn",
    Punjabi: "pa",
    Gujarati: "gu",
    Urdu: "ur",
    Persian: "fa",
    Turkish: "tr",
    Dutch: "nl",
    Swedish: "sv",
    Polish: "pl",
    Finnish: "fi",
    Thai: "th",
    Vietnamese: "vi",
    "No additional track is available": "und",
  };
 
  const aa = player?.getVariantTracks();
  console.log("aa", aa);
  const uniqueLanguages = [...new Set(aa?.map((track) => track.language))];
  console.log("uniqueLanguagesqqq", uniqueLanguages);
  let uniqueLanguageData = uniqueLanguages
    ?.map((langCode) =>
      Object.keys(languageMap).find((key) => languageMap[key] === langCode)
    )
    .filter(Boolean); // Remove undefined values if any language code is missing in languageMap
  uniqueLanguageData = uniqueLanguageData.length
    ? uniqueLanguageData
    : ["No additional track is available"];
 
  console.log("uniqueLanguageData", uniqueLanguageData);
 
  const uniqueSubtitle = new Set();
  const uniqueSubtitleData = ["OFF"];
  const textTracks = player?.getTextTracks();
  textTracks?.forEach((language) => {
    if (language.label && !uniqueSubtitle?.has(language.label)) {
      uniqueSubtitle?.add(language.label);
      uniqueSubtitleData?.push(language.label);
    }
  });
  console.log("selectedSubtitle", language, subtitle);
 
  const [activeTab, setActiveTab] = useState("Language");
  const [selectedQuality, setSelectedQuality] = useState(
    language || uniqueLanguageData[0]
  );
  const [selectedSpeed, setSelectedSpeed] = useState(
    subtitle || uniqueSubtitleData[0]
  );
 
  const [ActiveLangueage, setActiveLangueage] = useState(selectedQuality || "");
  const [ActiveSubtitle, setActiveSubtitle] = useState(subtitle || "");
  const qualityRefs = useRef(uniqueLanguageData);
  const speedRefs = useRef(uniqueSubtitleData);
  const speedLabel = uniqueSubtitleData;
  var qualityLabel = uniqueLanguageData;
 
  let indexACtive = qualityLabel.indexOf(selectedQuality);
 
  const [ActiveIndex, setActiveIndex] = useState(indexACtive);
  
  // Add mounted ref to prevent state updates after unmount
  const isMountedRef = useRef(true);
 
  const handleSubtitle = async (quality) => {
    if (!isMountedRef.current) return;
    
    setActiveSubtitle(quality);
    if (quality === "OFF") {
      player.setTextTrackVisibility(false); // Turn off subtitles
    } else {
      player.setTextTrackVisibility(true); // Turn on subtitles
      const tracks = player.getTextTracks();
      const selectedTrack = tracks.find((track) => track.label === quality);
      if (selectedTrack) {
        player.selectTextTrack(selectedTrack);
      }
    }
    const isLiveChannel = itemData[0]?.still_live === 1;
    const contentType = isLiveChannel ? "LiveChannel" : "Video";
    const videoType = itemData?.[0]?.category_title;
 
 
    const eventCategory = "SelectLanguagePopup";
    const eventAction = "Select";
    let eventName = "";
    const itemId = itemData[0]?.id || "";
    const itemTitle = itemData[0]?.title || "";
    const currentTitle = CurrentItemData?.title ?? itemData[0].season[0].title ?? "";
    const subtitleValue = quality || "unknown";
    const formattedSubtitle =
      subtitleValue.charAt(0).toUpperCase() +
      subtitleValue.slice(1).toLowerCase();
 
    if (videoType === "Shows") {
      const currentSeasonNumber = itemData[0]?.season?.[0]?.number;
      const episodeNumber = currentTitle.match(/\d+/g)?.[0] ?? "1";
      eventName = `${contentType}/${itemId}/${itemTitle}-S${currentSeasonNumber} E${episodeNumber} ${currentTitle}/Subtitle(${formattedSubtitle})`;
    } else if (videoType === "Movies") {
      eventName = `${contentType}/${itemId}/${itemTitle}-${itemTitle}/Subtitle(${formattedSubtitle})`;
    }
 
    await sendTestMatomoEvent({
      eventCategory,
      eventAction,
      eventName,
    });
  };
 
  const handleLanguage = (selectedLanguage, index) => {
    if (!isMountedRef.current) return;
    
    console.log("selectedLanguage", selectedLanguage);
    console.log("index", index);
    setActiveLangueage(selectedLanguage);
    setActiveIndex(index);
 
    const videoType = itemData?.[0]?.category_title;
 
    const { id: itemId, title: itemTitle } = itemData[0];
 
    const currentTitle =
      CurrentItemData?.title ?? itemData?.[0].season[0].title ?? "";
    const currentSeason = itemData?.[0]?.season?.[0];
    const currentSeasonNumber = currentSeason?.number;
    const episodeNumber = currentTitle.match(/\d+/g)?.[0] ?? "1";
    const isLiveChannel = itemData[0]?.still_live === 1;
 
    console.log(itemData, "isLiveChannel");
 
    const contentType = isLiveChannel ? "LiveChannel" : "Video";
 
    // console.log(itemData, CurrentItemData, "item1");
 
    let eventCategory = "SelectLanguagePopup";
    let eventAction = "Select";
    let eventName = "";
 
    switch (videoType) {
      case "TV Channels":
        eventName = `${contentType}/${itemId}/${itemTitle}/Language(${selectedLanguage})`;
        break;
 
      case "Live":
        eventName = `${contentType}/${itemId}/${itemTitle}/Language(${selectedLanguage})`;
        break;
 
      case "Shows":
        eventName = `${contentType}/${itemId}/${itemTitle}-S${currentSeasonNumber} E${episodeNumber} ${currentTitle}/Language(${selectedLanguage})`;
        break;
 
      case "Movies":
        eventName = `${contentType}/${itemId}/${itemTitle}-${itemTitle}/Language(${selectedLanguage})`;
        break;
 
      default:
        return; // or handle unknown type
    }
    sendTestMatomoEvent({ eventCategory, eventAction, eventName });
 
    const languageCode = languageMap[selectedLanguage]; // Convert full name to code
 
    if (!languageCode) {
      console.warn("Language not found in map:", selectedLanguage);
      return;
    }
 
    const tracks = player.getVariantTracks(); // Get available tracks
   
    const activeTrack = tracks.find(t => t.active === true);
    const currentHeight = activeTrack ? activeTrack.height : null;
 
 
    let matchingTrack = tracks.find(
      (track) => track.language === languageCode && track.height === currentHeight
    );
    if (!matchingTrack) {
        matchingTrack = tracks.find(
            (track) => track.language === languageCode
        );
    }
 
    if (matchingTrack) {
      player.selectVariantTrack(matchingTrack, true); // Change language
      console.log(`Switched to: ${selectedLanguage} (${languageCode})`);
    } else {
      console.warn("No matching track found for language:", selectedLanguage);
    }
  };
 
  useEffect(() => {
    sendTestMatomoEvent({
      eventCategory: "(VideoPlayer)",
      eventAction: "View",
      eventName: "SelectLanguagePopup",
    });
  }, []);
 
  useEffect(() => {
 
    const isLiveChannel = itemData?.[0]?.still_live === 1;
 
    if (isLiveChannel) return;
 
 
    if (activeTab === "Language") {
      const index = qualityLabel.indexOf(language);
      if (index !== -1) {
        if (isMountedRef.current) {
          qualityRefs.current[index]?.focus();
        }
      } else {
        if (isMountedRef.current) {
          qualityRefs.current[0]?.focus();
        }
      }
    } else if (activeTab === "Subtitle") {
      const index = speedLabel.indexOf(subtitle);
      if (index !== -1) {
        if (isMountedRef.current) {
          speedRefs.current[index]?.focus();
        }
      } else {
        if (isMountedRef.current) {
          speedRefs.current[0]?.focus();
        }
      }
    }
  }, [activeTab, subtitle, language, itemData]);
 
  useEffect(() => {
    // Set focus on the first quality option when the page loads or when switching tabs
    if (activeTab === "Language") {
      const index = qualityLabel.indexOf(language);
      if (index !== -1) {
        if (isMountedRef.current) {
          qualityRefs.current[index]?.focus();
        }
      } else {
        if (isMountedRef.current) {
          qualityRefs.current[0]?.focus();
        }
      }
    } else if (activeTab === "Subtitle") {
      const index = speedLabel.indexOf(subtitle);
      if (index !== -1) {
        if (isMountedRef.current) {
          speedRefs.current[index]?.focus();
        }
      } else {
        console.log(subtitle, index, "index");
        if (isMountedRef.current) {
          speedRefs.current[0]?.focus();
        }
      }
    }
  }, [activeTab, subtitle, language]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);
 
  const handleTabChange = (tab) => {
    if (!isMountedRef.current) return;
    setActiveTab(tab);
  };
 
  const handleKeyDown = (e, index, type) => {
    if (!isMountedRef.current) return;
    
    setActiveIndex(null);
    if (e.key === "Enter" || e.keyCode === 13) {
      e.preventDefault();
      e.stopPropagation();
 
      if (type === "Language") {
        const selectedLang = qualityLabel[index];
        handleLanguage(selectedLang, index);
        handleLanguageChange(selectedLang);
      } else if (type === "Subtitle") {
        const selectedSub = speedLabel[index];
        handleSubtitle(selectedSub);
        handleSubtitleChange(selectedSub);
      }
    }
    else if (type === "Language") {
      if (e.key === "ArrowDown" && index < qualityRefs.current.length - 1) {
        setSelectedQuality(qualityLabel[index + 1]);
        qualityRefs.current[index + 1]?.focus();
      } else if (e.key === "ArrowUp") {
        if (index > 0) {
          setSelectedQuality(qualityLabel[index - 1]);
          qualityRefs.current[index - 1]?.focus();
        }
      } else if (e.key === "ArrowRight") {
        setActiveTab("Subtitle");
      }
    } else if (type === "Subtitle") {
      if (e.key === "ArrowDown" && index < speedRefs.current.length - 1) {
        setSelectedSpeed(speedLabel[index + 1]);
        speedRefs.current[index + 1]?.focus();
      } else if (e.key === "ArrowUp") {
        if (index > 0) {
          setSelectedSpeed(speedLabel[index - 1]);
          speedRefs.current[index - 1]?.focus();
        }
      } else if (e.key === "ArrowLeft") {
        setActiveTab("Language");
      }
    }
  };
  return (
    <div style={styles.settingsMenu} className="settings-container">
      <h4 style={{ fontSize: "18px", fontWeight: "600" }}>Language</h4>
 
      <div style={styles.tabs}>
        <button
          style={{
            ...styles.tabButton,
            ...(activeTab === "Language" ? styles.activeTab : {}),
          }}
          onClick={() => handleTabChange("Language")}
        >
          <Translate langKey={"language"} />
        </button>
        <button
          style={{
            ...styles.tabButton,
            ...(activeTab === "Subtitle" ? styles.activeTab : {}),
          }}
          onClick={() => handleTabChange("Subtitle")}
        >
          <Translate langKey={"subtitle"} />
        </button>
      </div>
 
      {activeTab === "Language" && (
        <div style={styles.qualityOptions}>
          {qualityLabel.length > 0 &&
            qualityLabel.map((quality, index) => (
              <div
                key={quality}
                tabIndex={0}
                ref={(el) => (qualityRefs.current[index] = el)}
                style={{
                  ...styles.qualityOption,
                  ...(selectedQuality === quality ? styles.selectedOption : {}),
                }}
                onClick={() => {
                handleLanguage(quality, index);
                handleLanguageChange(quality);
              }}
                onKeyDown={(e) =>
                  handleKeyDown(
                    e,
                    ActiveIndex ? ActiveIndex : index,
                    "Language"
                  )
                }
              >
                {quality}
                {ActiveLangueage != "No additional track is available" &&
                  ActiveLangueage === quality && (
                    <span style={styles.checkmark}>✔</span>
                  )}
              </div>
            ))}
        </div>
      )}
 
      {activeTab === "Subtitle" && (
        <div style={styles.speedOptions}>
          {speedLabel.length > 0 &&
            speedLabel.map((speed, index) => (
              <div
                key={speed}
                tabIndex={0}
                ref={(el) => (speedRefs.current[index] = el)}
                style={{
                  ...styles.qualityOption,
                  ...(selectedSpeed === speed ? styles.selectedOption : {}),
                }}
                onClick={() => {
                  setSelectedSpeed(speed);
                  // onBitrateChange(speed);
                  handleSubtitle(speed);         // Logic
                  handleSubtitleChange(speed);   // Menu Band
                }}
                onKeyDown={(e) => handleKeyDown(e, index, "Subtitle")}
              >
                {speed}
                {ActiveSubtitle === speed && (
                  <span style={styles.checkmark}>✔</span>
                )}
              </div>
            ))}
        </div>
      )}
    </div>
  );
};
 
const styles = {
  settingsMenu: {
    backgroundColor: "rgb(0, 0, 0)",
    opacity: "0.8",
    color: "rgb(255, 255, 255)",
    padding: "20px",
    width: "300px",
    borderRadius: "8px",
    fontFamily: "Anek Latin",
    float: "right",
    position: "absolute",
    right: "0px",
    height: "95vh",
  },
  tabs: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "20px",
  },
  tabButton: {
    backgroundColor: "rgb(31, 31, 31)",
    color: "white",
    border: "none",
    padding: "10px 20px",
    cursor: "pointer",
    fontSize: "16px",
    borderRadius: "5px",
    width: "50%", // Ensure equal width for both tabs
  },
  settingsMenuTab: {
    backgroundColor: "rgb(31, 31, 31)",
    color: "white",
    border: "none",
    padding: "10px 20px",
    cursor: "pointer",
    fontSize: "16px",
    borderRadius: "5px",
    width: "100%", // Ensure equal width for both tabs
    textAlign: "left",
  },
  activeTab: {
    backgroundColor: "#EC008C",
    color: "white",
  },
  activeTabs: {
    textAlign: "left",
  },
  qualityOptions: {
    display: "flex",
    flexDirection: "column",
  },
  qualityOption: {
    backgroundColor: " rgb(31, 31, 31)",
    padding: "10px 20px",
    margin: "5px 0",
    borderRadius: "5px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
    fontSize: "16px",
    outline: "none", // Remove the default outline when focused
  },
  selectedOption: {
    backgroundColor: " #EC008C",
  },
  checkmark: {
    fontSize: "18px",
  },
  speedOptions: {
    display: "flex",
    flexDirection: "column",
  },
};
 
export default VideoLanguagePage;